import { render } from "./incident-breadcrumb.vue?vue&type=template&id=340f1c36"
import script from "./incident-breadcrumb.vue?vue&type=script&lang=js"
export * from "./incident-breadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__